import React, { useContext, useCallback, useState } from 'react';
import ModalCtrl from 'sg-modal-ctrl';
import useSgSptCountries from 'sg-use-spt-countries';
import { TranslatorContext } from '@jutro/locale';
import _ from 'lodash';
import SgTypeAheadComponent from 'sg-typeahead-component';
import { Link } from '@jutro/components';
import { SgWebchatUtil } from 'saga-modules';
import messages from './SgSptRegionHelperModal.messages';

function SgSptRegionHelperModal(props) {
    const {
        isOpen,
        onResolve,
        modelVM,
        usaOnly,
        readOnlyContext
    } = props;

    const translator = useContext(TranslatorContext);
    const {
        availableCountries,
        findRegionByCountry,
        euCountryNames,
        woiCountryNames
    } = useSgSptCountries(modelVM.value);
    const [selectedCountry, setSelectedCountry] = useState(undefined);
    const [resultFound, setResultFound] = useState(undefined);
    const [showNoResultFoundString, setShowNoResultFoundString] = useState('');
    const [selectedCountryRegion, setSelectedCountryRegion] = useState(undefined);

    const getCountriesListJsx = useCallback((list) => {
        return (
            <ul className={usaOnly ? 'sgSptCountriesListUsaOnly' : 'sgSptCountriesList'}>
                {list.map((item) => {
                    return (<li key={item}>{item}</li>);
                })}
            </ul>
        );
    }, []);

    const onValueChange = useCallback((newCountry) => {
        setResultFound(true);
        setShowNoResultFoundString('');
        setSelectedCountry(newCountry);
        setSelectedCountryRegion(findRegionByCountry(newCountry));
    }, [setSelectedCountry]);

    const onBlur = useCallback((value) => {
        setResultFound(undefined);
        if (!_.isEmpty(value)) {
            setShowNoResultFoundString(value);
            setResultFound(false);
        } else {
            setShowNoResultFoundString('');
        }
        setSelectedCountry(undefined);
    }, [setSelectedCountry, setShowNoResultFoundString, setResultFound]);

    const onRenderItem = (item) => {
        return item.name;
    };

    const trackChat = useCallback((event) => {
        if (event) {
            event.preventDefault();
        }
        SgWebchatUtil.trackChat();
    }, []);

    const getModalJsx = (
        <>
            {usaOnly
                ? (
                    <>
                        {getCountriesListJsx(woiCountryNames)}
                    </>
                )
                : (
                    <>
                        <div className="sgSptRegionSearchContainer">
                            <h3 id="sgSptSearchCountryRegionHeader">{translator(messages.SgSptRegionHelperNotSureHeader)}</h3>
                            <SgTypeAheadComponent
                                id="sgSptRegionHelperLookup"
                                className="sgTripDestinationTypeahead"
                                value={selectedCountry ? selectedCountry.name : ''}
                                defaultValueMessage={translator(messages.SgSptRegionHelperSearchNoMatch, { value: showNoResultFoundString })}
                                noResultsFound={resultFound === false}
                                items={availableCountries}
                                searchBy="name"
                                minLetters={1}
                                onValueChange={onValueChange}
                                handleOnBlur={onBlur}
                                onRenderItem={onRenderItem}
                                placeholder={translator(messages.SgSptRegionHelperSearchPlaceholder)}
                                showSearchIcon
                                setSingleResultOnBlur
                            />
                            <div id="sgSptRegionHelperSearchResult">
                                {!_.isNil(selectedCountry) && (
                                    <div className="sgSptRegionSearchResultContainer">
                                        <span>
                                            {translator(messages.SgSptRegionResult, {
                                                country: selectedCountry.name,
                                                region: translator(messages[`Region_${selectedCountryRegion}`])
                                            })}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                        {readOnlyContext && (
                            <h3>{translator(messages.SgSptRegionHelperModalAlternativeHeader)}</h3>
                        )
                        }
                        <h3>{translator(messages.SgSptRegionHelperModalEuropeHeader)}</h3>
                        <p>{translator(messages.SgSptRegionHelperModalEuropeParagraph)}</p>
                        {getCountriesListJsx(euCountryNames)}
                        <h3>{translator(messages.SgSptRegionHelperModalWorldwideHeader)}</h3>
                        <p>
                            {
                                translator(readOnlyContext ? messages.SgSptRegionHelperModalAlternativeWorldwideFirstParagraph
                                    : messages.SgSptRegionHelperModalWorldwideFirstParagraph)
                            }
                        </p>
                        {getCountriesListJsx(woiCountryNames)}
                        <p>{translator(messages.SgSptRegionHelperModalWorldwideSecondParagraph)}</p>
                        {readOnlyContext && (
                            <span>
                                <p id="webchatMessageRegionHelper">
                                    {translator(messages.SgSptRegionHelperModalAlternativeWorldwideThirdParagraph)}
                                    <Link
                                        href="/"
                                        id="webchatlinkRegionHelper"
                                        onClick={trackChat}
                                        className="saga-intercom"
                                    >
                                        {translator(messages.SgSptRegionHelperModalAlternativeWorldwideThirdParagraphWebChat)}
                                    </Link>
                                    {translator(messages.SgSptRegionHelperModalAlternativeWorldwideThirdParagraphAlternatively)}
                                </p>
                            </span>
                        )
                        }
                    </>
                )
            }
        </>
    );

    const modalProps = {
        title: translator(messages.SgSptRegionHelperModalHeaderUSA),
        titleVisibility: usaOnly,
        className: 'sgInfoModal',
        closeBtnLabel: messages.SgSptRegionHelperModalCloseButtonLabel,
        isOpen,
        onResolve,
        modalJsx: getModalJsx
    };

    return <ModalCtrl {...modalProps} />;
}

export default SgSptRegionHelperModal;
